import { Users, Heart, FileCheck, Zap } from "lucide-react";

const ProvidersGainSection = () => {
  const benefits = [
    {
      icon: Users,
      title: "More Time with Patients",
      description: "Spend less time on paperwork and more time delivering quality care to your patients.",
      stat: "3+ hrs",
      statLabel: "saved daily",
    },
    {
      icon: Heart,
      title: "Reduced Burnout",
      description: "Eliminate documentation fatigue and restore work-life balance for healthcare providers.",
      stat: "60%",
      statLabel: "less stress",
    },
    {
      icon: FileCheck,
      title: "Improved Accuracy",
      description: "AI-enhanced documentation with quality review ensures precise, compliant records.",
      stat: "99.9%",
      statLabel: "accuracy rate",
    },
    {
      icon: Zap,
      title: "Faster Turnaround",
      description: "Charts ready for review and signing within 24 hours, keeping your workflow on track.",
      stat: "24hr",
      statLabel: "turnaround",
    },
  ];

  return (
    <section 
      data-testid="providers-gain-section"
      className="py-16 sm:py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-xs sm:text-sm font-medium uppercase tracking-widest text-cyan-500 mb-3 sm:mb-4 block">
            The Benefits
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            What Providers Gain
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto px-4">
            Measurable improvements that transform your practice
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="glass-card p-4 sm:p-6 md:p-8 card-hover-lift group text-center"
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 sm:mb-6 rounded-xl sm:rounded-2xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center group-hover:bg-cyan-500/20 transition-colors">
                <benefit.icon className="w-6 h-6 sm:w-8 sm:h-8 text-cyan-400" />
              </div>
              
              {/* Stat */}
              <div className="mb-3 sm:mb-4">
                <span className="text-2xl sm:text-4xl font-bold text-cyan-400">{benefit.stat}</span>
                <p className="text-[10px] sm:text-xs text-slate-500 uppercase tracking-wide mt-1">{benefit.statLabel}</p>
              </div>
              
              <h3 className="text-sm sm:text-lg font-semibold text-white mb-2 sm:mb-3">{benefit.title}</h3>
              <p className="text-xs sm:text-sm text-slate-400 leading-relaxed hidden sm:block">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProvidersGainSection;
